import { useEffect } from 'react';
import track from './track';

export type PageCategory = 'gojob.com' | 'blog';

const useTrackPageview = (slug?: string, pageCategory: PageCategory = 'gojob.com') => {
  useEffect(() => {
    if (slug) {
      // remove trailing '/' if present
      const pageName = slug.replace(/(.)(\/)$/, '$1');
      track('page', { pageCategory, pageName });
    }
  }, [slug]);
};

export default useTrackPageview;
